export default __webpack_public_path__ + "static/media/undraw_loading.b7bb8119.svg";